import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Whatsapp from "./assets/img/whatsapp.png";
import ScrollToTop from './components/ScrollToTop';
import NotFound from './pages/404';
import Home from './pages/web/Home';
import About from './pages/web/About';
import Property from './pages/web/Property';
import Request from './pages/web/Request';
import Agents from './pages/web/Agents';
import Contact from './pages/web/Contact';
import Terms from './pages/Terms';
import PropertyDetails from './pages/web/PropertyDetails';
import Login from './pages/admin/Login';
import Signup from './pages/admin/Signup';
import Dashboard from './pages/admin/Dashboard';
import AddProperty from './pages/admin/AddProperty';
import MyListing from './pages/admin/MyListing';
import Profile from './pages/admin/Profile';
import ViewRequest from './pages/admin/ViewRequest';
import FAQs from './pages/web/FAQs';
import AllProperties from './pages/admin/AllProperties';
import AllAgents from './pages/admin/AllAgents';
import Subscription from './pages/admin/Subscription';
import SubscriptionForm from './pages/admin/SubscriptionForm';
import AllSubscriptions from './pages/admin/AllSubscriptions';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/property" element={<Property />} />
          <Route path="/request" element={<Request />} />
          <Route path="/agents" element={<Agents />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/property-details/:id" element={<PropertyDetails />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/add-property" element={<AddProperty />} />
          <Route path="/my-listing" element={<MyListing />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/requests" element={<ViewRequest />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/properties" element={<AllProperties />} />
          <Route path="/all-agents" element={<AllAgents />} />
          <Route path="/plans" element={<Subscription />} />
          <Route path="/plans/payment-form" element={<SubscriptionForm />} />
          <Route path="/subscriptions" element={<AllSubscriptions />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <a href="https://wa.me/2348162230411" target="_blank" className="whatsapp">
        <img src={Whatsapp} alt='Whatsapp Link' />
      </a>
    </div>
  );
}

export default App;
